import React, { useState } from "react";
import styled, { css } from "styled-components";
import compileSyndicationsAppearancesCoverage from "../../utilities/compileSyndicationsPressCoverage";
//import Globe from "../GlobeGl";
import OuiOverflowScroll from "../oui/OuiOverflowScroll";
import ArticleSyndicationList from "./ArticleSyndicationList";

const ClientSideOnlyLazy = React.lazy(() =>
  import("../GlobeGl")
)

const ArticleReach = ({ syndications = [], appearances = [], coverage = [] }) => {
  
  const [selectedCountry, setSelectedCountry] = useState(undefined);

  const compiled = compileSyndicationsAppearancesCoverage( syndications, appearances, coverage );
  const countries = compiled.countries;

  const isSSR = typeof window === "undefined"

  const gData = [];
  compiled.countries.forEach(( country ) => {
    gData.push({ lat: country.coordinates.coordinates[1], lng: country.coordinates.coordinates[0], size: 0.2, color: "blue", id: country.id, label: country.name });
  });

  return (
    <StyledArticleReach id="impact">
      <StyledArticleReachHeader>
        <h2>Published Across the Globe</h2>
        <p>Reporting from this story ran in outlets around the world.</p>
        <StyledStats>
          <li><em>{compiled.countOutlets}</em><span>Outlets</span></li>
          <li><em>{compiled.countCountries}</em><span>Countries</span></li>
          <li><em>{compiled.countLanguages}</em><span>Languages</span></li>
        </StyledStats>
      </StyledArticleReachHeader>
      <figure>

        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <ClientSideOnlyLazy gData={gData} setSelectedCountry={setSelectedCountry} />
          </React.Suspense>
        )}
        
      </figure>
      {/*<ArticleSyndicationList syndications={syndications} appearances={appearances} coverage={coverage} />*/}
    </StyledArticleReach>
  );
};
export default ArticleReach;


const StyledStats = styled.ul`
  position: relative;
  display: inline-grid;
  grid-template: auto / 1fr 1fr 1fr;
  grid-gap: 2em;
  list-style: none;
  padding: 0;
  margin: 0 auto;
  li {
    text-align: center;
    line-height: 1;
  }
  em {
    font-family: var(--font-heading);
    font-size: 2em;
    font-weight: 700;
    font-style: normal;
    display: block;
  }
  span {
    font-size: 0.75em;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;

const StyledArticleReachHeader = styled.header`
  position: relative;
  text-align: center;
  z-index: 10;
  max-width: var(--text-max-width);
  margin: 0 auto;
  margin-top: 3em;
  padding-top: 3em;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ( min-width: 48em ) {
    margin-top: 4.5em;
    padding-top: 5em;
    margin-bottom: -6em;
  }
  h2 {
    font-family: var(--font-heading);
    font-size: 1.25em;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  p {
    font-family: var(--font-serif);
    font-size: 1.5em;
    margin: 0.5em 0 1em;
  }
  @media ( min-width: 48em ) {
    h2 {
      font-size: 1.5em;
    }
  }
`;

const StyledArticleReach = styled.aside`
  position: relative;
  display: flex;
  flex-direction: column;
  @media ( min-width: 60em ) {
    padding: 0 6.8125em;
  }
  > figure {
    position: relative;
    max-height: 48em;
    width: 100%;
    max-width: 48em;
    margin: 0 auto;
    order: 2;
    transition: transform 0.6s ease;
  }
  > details {
    order: 3;
    z-index: 5;
  }

  @media ( max-width: 48em ) {
    > figure {
      height: 0;
      padding-bottom: 100%;
    }
  }
`;
